$(function() {

    // https://michalsnik.github.io/aos/
    AOS.init({
        duration: 1000,
        once:true,
    });
  
	/*
	* BACK TO TOP
	*/
	$('.back-to-top').on('click', function(){
		$('html, body').animate({scrollTop : 0},800);
		return false;
	});


	$('.js-product_cat-filter-link').on('click', function(){

        $(this).parent().addClass('active').siblings().removeClass('active');

        _index = $(this).parent().index();
        $('.js-product_cat-list').find('> li').eq(_index).addClass('active').siblings().removeClass('active');

        return false;
    });

});











/*
$(window).on('scroll', function(){
	sticky_navigation();
});


	sticky_navigation();
	var sticky_navigation_offset_top;
	function sticky_navigation(){
		var scroll_top = $(window).scrollTop();
		sticky_navigation_offset_top = 100;//$(document).width() >= 768 ? 0 : 0;
		if (scroll_top > sticky_navigation_offset_top) { 
			$('body').removeClass('scroll-top');
		} else {
			$('body').addClass('scroll-top');
		}   
	};
*/	
